export default "__VITE_ASSET__C$A1sl6p__"